module.exports = __webpack_public_path__ + "media/images/chevron-down-8706dd55c1164d4d31082beaeb16348a.svg";